import { User, UserRoleType } from '@/services/users/users.types';

export const checkUserAccess = (user: User, roles: UserRoleType[]): boolean => {
  if (!user) return false;
  if (Array.isArray(roles) && roles.length === 0) return true;
  return user?.roles?.some(userRole => {
    return userRole.name === UserRoleType.ADMIN || roles?.includes(userRole.name);
  });
};

// Returns true only if the user literally has one of the given roles (no admin bypass).
// Used to build strict lists (e.g. "commercial" pickers) that must not include admins
// who don't actually hold the role.
export const hasStrictRole = (user: User, roles: UserRoleType[]): boolean => {
  if (!user || !Array.isArray(roles) || roles.length === 0) return false;
  return !!user.roles?.some(userRole => roles.includes(userRole.name));
};

// Returns true if the user should be excluded (has an excluded role and is not admin)
export const checkUserExcluded = (user: User, excludeRoles?: UserRoleType[]): boolean => {
  if (!user || !excludeRoles || excludeRoles.length === 0) return false;
  const isAdmin = user.roles?.some(r => r.name === UserRoleType.ADMIN);
  if (isAdmin) return false;
  return user.roles?.some(r => excludeRoles.includes(r.name));
};

// Accès à la gestion des tâches (page /tasks + cloche de notifications navbar) :
// réservé aux membres d'au moins une équipe "Assignable aux tâches" (Team#task_assignable),
// un admin y a toujours accès quelle que soit son équipe.
export const hasTaskManagementAccess = (user: User): boolean => {
  if (!user) return false;
  if (user.roles?.some(r => r.name === UserRoleType.ADMIN)) return true;
  return !!user.teams?.some(t => t.task_assignable);
};
